import { editorPicks } from '@/mocks/comics';

const labels = [
  { tag: '小编力荐', no: '01', blurb: '打工人必看，笑点密集' },
  { tag: '编辑精选', no: '02', blurb: '恋爱喜剧天花板' },
  { tag: '本周必读', no: '03', blurb: '沙雕网友都在看' },
];

export default function EditorsPick() {
  return (
    <section id="picks" className="w-full bg-background-100 py-14 md:py-20" aria-labelledby="picks-title">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-star-smile-line" aria-hidden="true"></i>
              小编精选
            </span>
            <h2 id="picks-title" className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
              编辑私藏爆笑合集
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              这几部是被小编翻牌无数次的笑死人不偿命神作，闭眼入不踩雷。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-3">
          {editorPicks.map((c, i) => (
            <article
              key={c.id}
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:shadow-soft"
              data-product-shop
            >
              <div className="relative aspect-[16/10] w-full overflow-hidden">
                <img
                  src={c.cover}
                  alt={`${c.title} 搞笑漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-full bg-foreground-950/55 px-3 py-1 font-label text-sm text-background-50 backdrop-blur-sm">
                  {labels[i].tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2">
                  <span className="font-heading text-2xl text-accent-500">{labels[i].no}</span>
                  <h3 className="truncate font-heading text-lg text-foreground-950">
                    <a href="#comics" className="hover:text-primary-600">
                      {c.title}
                    </a>
                  </h3>
                </div>
                <p className="mt-2 text-sm text-foreground-600">{labels[i].blurb}</p>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{c.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-400">已更新至第 {c.chapters} 话</span>
                  <a
                    href="#comics"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
                  >
                    去追更
                    <i className="ri-arrow-right-line" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}